import { IQuotation } from '@/interfaces';

export default (): IQuotation => {
	return {
		products: {},
		caches: [],
		synonymsProducts: [],
		synonyms: {},
		shiftResults: [],
		filesToUpload: {}
	};
};
